import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import { Label } from 'reactstrap';

export interface IResultsFormProps {
  searchResults: any;
  searchingMessage: string;
  searching: boolean;
  provider: string;
}

export class SearchResults extends React.Component<IResultsFormProps, any> {

  public render() {
    const matchType = this.props.provider.includes('biometrica') ? 'biometrica' : 'adhoc';

    return (
      <div>
        {
          this.props.searching ?
            <div className="search-loader">
              <Label id="loadingText" className="text-center saving-text">Searching...</Label>
              <PulseLoader size={15} color={'#db8733'} loading={this.props.searching} />
            </div>
            :
            this.props.searchResults.length > 0 ?
              <>
                <Redirect to={`/rekognition/matches/${matchType}/${matchType !== 'biometrica' ?
                  this.props.searchResults[0].searchId : this.props.searchResults[0].matchId} `} />
              </>
              :
              <div>
                {this.props.searchingMessage}
              </div>
        }
      </div>
    );
  }
}

export default SearchResults;
